var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgCourseNegative(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fillRule: "evenodd"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M14.8 15.095l.104-.2.44-.837.6 1.034.926 1.597H20l-2.98-4.434 2.84-4.247h-3.104l-.866 1.63-.433.882-.484-.892-.905-1.615h-3.1l2.8 4.292L10.86 16.7h3.103l.838-1.604z",
    fill: "#e62e2d"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.134 15.278h-5.23v.608h-.453v-.608h-.3C2.307 15.278 0 12.66 0 9.438s2.307-5.83 5.142-5.83h5.3V3h.452v.608h.46c2.318 0 4.28 1.75 4.92 4.148l-.847 1.575-.012-.022-1.052-1.892h-.596c-.548-.838-1.425-1.386-2.414-1.386h-.46v.608h-.452v-.607h-5.3c-1.658 0-3.007 1.53-3.007 3.41s1.35 3.41 3.007 3.41h.3v-.608h.452v.608h5.45a2.75 2.75 0 001.708-.607l.04.067-1.968 2.963z",
    fill: "#010101",
    fillRule: "nonzero"
  })));
}
export default SvgCourseNegative;